module.exports = __webpack_public_path__ + "static/media/survey.24f00d1a.svg";